import { BubbleType, Bubble } from '../../bubbles/types';
import { BubbleView } from './BubbleView';
import { BubbleViewHandler } from './BubbleViewHandler';
import { RegularViewHandler } from './coreViewHandlers/RegularViewHandler';
import { FireViewHandler } from './coreViewHandlers/FireViewHandler';

type ViewHandlerClass<T extends BubbleType> = new (view: BubbleView, model: Bubble<T>) => BubbleViewHandler<T>;

export function createViewHandler<T extends BubbleType>(
  view: BubbleView, model: Bubble<T>
): BubbleViewHandler<T> {
  // @ts-ignore
  return new typeHandlerMap[model.core.type](view, model);
}

const typeHandlerMap: { [key in BubbleType]: ViewHandlerClass<key> } = {
  [BubbleType.Regular]: RegularViewHandler,
  [BubbleType.Fire]: FireViewHandler,
}